import { observable, action } from 'mobx';

import { provideSingleton, inject } from '../utils/decorators';
import { IObjektListeResponse, IVorgang, IVorgangVorlage } from '../models/ApiTypes';
import { ApiStore } from './ApiStore';

/** Singleton für aktuellen Vorgang */
@provideSingleton(VorgangStore)
export class VorgangStore {

  @inject(ApiStore) apiStore: ApiStore;

  @observable vorgang?: IVorgang = undefined;
  @observable vorlage?: IVorgangVorlage = undefined;
  @observable objekte?: IObjektListeResponse = undefined;


  @action setVorgang(vorgang: IVorgang | undefined) {
    this.vorgang = vorgang;
  }

  @action setVorlage(vorlage: IVorgangVorlage | undefined) {
    this.vorlage = vorlage;
  }

  @action setObjekte(objekte: IObjektListeResponse | undefined) {
    this.objekte = objekte;
  }

  @action clearVorgang() {
    this.vorlage = undefined;
    this.vorgang = undefined;
  }

  @action clearObjekte() {
    this.objekte = undefined;
  }

  @action setAbgeschlossen() {
    if (this.vorgang && !this.vorgang.abgeschlossen) {
      this.vorgang.abgeschlossen = true;
    }
  }

  async loadVorgang(vorgangId: string, vorlageAbgefragtHandler?: (geladen: boolean) => void) {
    if (vorlageAbgefragtHandler) {
      vorlageAbgefragtHandler(false);
    }
    this.clearVorgang();
    const response = await this.apiStore.vorgangDetails(vorgangId);
    if (response.ok) {
      this.setVorgang(response.json);
    }

    const vorlage = await this.apiStore.vorgangVorlage(vorgangId);
    if (vorlage.ok) {
      this.setVorlage(vorlage.json);
    }
    if (vorlageAbgefragtHandler) {
      vorlageAbgefragtHandler(true);
    }

    this.loadObjekte(vorgangId);
  }

  async loadObjekte(vorgangId: string) {
    this.clearObjekte();
    const objektliste = await this.apiStore.vorgangObjekte(vorgangId);
    if (objektliste.ok) {
      this.setObjekte(objektliste.json);
    }
  }

  async messwerteSesVorhanden(vorgangId: string) {
    const response = await this.apiStore.messwerteSesVorhanden(vorgangId);
    return (response.ok && response.json.messwerte) ? true : false;
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/VorgangStore.ts